import { render, staticRenderFns } from "./Anonymous.vue?vue&type=template&id=22df49d0&lang=pug&"
import script from "./Anonymous.vue?vue&type=script&lang=js&"
export * from "./Anonymous.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports